import { useEffect, useState, useRef } from 'react'
import TextBoxControl from '../../Controls/TextBoxControl';
import ButtonControl from "../../Controls/ButtonControl"
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import "../../assets/css/Login.css"
import {
    SetLocal,
    ClearLocal,
    FetchService,
    IsValidNationalCode,
    IsEmptyString,
    IsEmptyInput,
    Base64Type,
    GetParamsUrl
} from "../../Base/BaseControl";
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';



export default function Index({ }) {




    const [showModal, setShowModal] = useState(false);
    const [getPdf, setPdf] = useState('');

    const navigate = useNavigate();


    useEffect(() => {
        if (GetParamsUrl("sys") && GetParamsUrl("rn") && (GetParamsUrl('k1') || GetParamsUrl('k2') || GetParamsUrl('k3'))) {
            GetReportInfo()

        }

    }, []);

    const GetReportInfo = () => {

        let inputValue = {
            systemNumber: GetParamsUrl("sys"),
            reportNumber: GetParamsUrl('rn'),
            key1: GetParamsUrl('k1'),
            key2: GetParamsUrl('k2'),
            key3: GetParamsUrl('k3'),
            regionID: GetParamsUrl('m') ? Number(GetParamsUrl('m')) : 0,
        };
        FetchService("General/GetReportInfo", inputValue, GetReportInfoSuccess, GetReportInfoFail);
    }



    const GetReportInfoSuccess = (ServiceResult) => {
        setPdf("data:application/pdf;base64," + ServiceResult);
        setShowModal(true)
    


    }
    const GetReportInfoFail = (error) => {
        toast.error(error)
       

    }









    return (
        <div id="bglogin">
            <div className="main">
                <div className="col-12 col-md-4">

                </div>
            </div>

            <Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe src={getPdf} width="100%" style={{ height: "500px" }}></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowModal(false)}>
                        بستن
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}